/**
 * ARIA inputs shared by select trigger buttons.
 */
export type SelectButtonA11yInput = {
  ariaLabel?: string
  ariaInvalid?: boolean
  describedById?: string
}

/**
 * Builds the ARIA attributes passed to the Headless UI listbox trigger.
 */
export const getSelectButtonA11yProps = ({ ariaLabel, ariaInvalid, describedById }: SelectButtonA11yInput) => ({
  'aria-label': ariaLabel,
  'aria-invalid': ariaInvalid || undefined,
  'aria-describedby': describedById,
})

